import RouteAppShell from '@/common/components/app-shell/RouteAppShell.tsx';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import MeSidebar from '@/features/me/components/MeSidebar.tsx';

export const Route = createFileRoute('/me')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RouteAppShell sidebar={{ children: <MeSidebar /> }}>
      <Outlet />
    </RouteAppShell>
  );
}
